import React from "react";
import { useAuth } from "../contexts/AuthContext";
import { useToast } from "../contexts/ToastContext";
import { useInactivityLogout } from "../hooks/useInactivityLogout";

const INACTIVITY_TIMEOUT_MS = 15 * 60 * 1000; // 15 minutos
const WARNING_BEFORE_MS = 1 * 60 * 1000; // 1 minuto antes

const InactivityWatcher = () => {
  const { logout, isAuthenticated } = useAuth();
  const toast = useToast();

  useInactivityLogout({
    enabled: isAuthenticated,
    onLogout: logout,
    onWarning: () => {
      toast.warning(
        "Tu sesión expirará en 1 minuto por inactividad. Mueve el ratón o haz clic para permanecer conectado."
      );
    },
    timeoutMs: INACTIVITY_TIMEOUT_MS,
    warningBeforeMs: WARNING_BEFORE_MS
  });

  return null;
};

export default InactivityWatcher;
